import React, { useState } from "react";
import axios from "axios";
import "../Styles/UploadVideo.css";

function UploadVideo({ refreshDashboard }) {

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!title || !file) {
      setError("Please enter video title and select a video.");
      return;
    }

    try {

      const formData = new FormData();

      formData.append("file", file);
      formData.append("title", title);
      formData.append("description", description);

      await axios.post(
        "/api/gallery/upload/video",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setMessage("Video uploaded successfully.");

      setTitle("");
      setDescription("");
      setFile(null);

      document.getElementById("videoFile").value = "";

      if (refreshDashboard) {
        refreshDashboard();
      }

    } catch (err) {

      console.error(err);

      setError(
        err.response?.data ||
        "Failed to upload video."
      );
    }
  };

  return (
    <div className="upload-video-page">

      <h2>Upload Video</h2>

      <form onSubmit={handleSubmit}>

        <div className="video-field">

          <label>Video Title</label>

          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter video title"
          />

        </div>


        <div className="video-field">

          <label>Description</label>

          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter video description"
            rows="5"
          />

        </div>


        <div className="video-field">

          <label>Select Video</label>

          <input
            id="videoFile"
            type="file"
            accept="video/*"
            onChange={(e) => setFile(e.target.files[0])}
          />

        </div>


        <button type="submit">
          Upload Video
        </button>

      </form>


      {message && (
        <p className="video-success">
          {message}
        </p>
      )}

      {error && (
        <p className="video-error">
          {error}
        </p>
      )}

    </div>
  );
}

export default UploadVideo;